import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { OfflineDialogComponent } from "./offline-dialog.component";

@NgModule({
	declarations: [OfflineDialogComponent],
	imports: [CommonModule, MaterialModule, TranslateModule],
	exports: [OfflineDialogComponent],
})
export class OfflineDialogModule {}
